import "./on_demand_call.scss";

let onDemandCallComponent = {
  restrict: "E",
  bindings: {},
};

export default onDemandCallComponent;



// WEBPACK FOOTER //
// ./client/app/components/on_demand_call/on_demand_call.component.js